import { memo } from 'react'

interface StarProps {
  width?: number
  height?: number
  className?: string
  style?: React.CSSProperties
  color?: string
}

export const SolidStar = memo(
  ({ width = 11, height = 13, className, style }: StarProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 13"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M5.5 9.49945L2.10111 11.5L2.86012 7.48268L0 4.70177L3.86826 4.21937L5.5 0.5L7.13174 4.21937L11 4.70177L8.13988 7.48268L8.89889 11.5L5.5 9.49945Z"
        fill={style?.color ?? 'currentColor'}
      />
    </svg>
  )
)

SolidStar.displayName = 'SolidStar'

export const OutlineStar = memo(
  ({ width = 11, height = 13, className, style }: StarProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M5.5 9.49945L2.10111 11.5L2.86012 7.48268L0 4.70177L3.86826 4.21937L5.5 0.5L7.13174 4.21937L11 4.70177C9.88306 5.78778 9.25683 6.39667 8.13988 7.48268L8.89889 11.5L5.5 9.49945Z"
        fill={style?.color ?? 'currentColor'}
      />
      <path
        d="M6.94873 4.30011L6.99463 4.40363L7.10693 4.41827L10.561 4.84894L8.00049 7.33917L7.92139 7.41632L7.94482 7.52472L8.71143 11.1097L6.51611 9.88214V3.31378L6.94873 4.30011Z"
        fill="white"
        stroke={style?.color ?? 'currentColor'}
        strokeWidth="0.4"
      />
    </svg>
  )
)

OutlineStar.displayName = 'OutlineStar'

export const EmptyStar = memo(
  ({ width = 11, height = 13, className, style }: StarProps) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M5.5 9.49945L2.10111 11.5L2.86012 7.48268L0 4.70177L3.86826 4.21937L5.5 0.5L7.13174 4.21937L11 4.70177L8.13988 7.48268L8.89889 11.5L5.5 9.49945Z"
        stroke={style?.color || 'currentColor'}
        fill="transparent"
      />
    </svg>
  )
)

EmptyStar.displayName = 'EmptyStar'
